import React from 'react';
import logo from './assets/logo.png'; // Correctly imports your custom logo from src/assets/

function App() {
  return (
      <div style={styles.container}>
        {/* Background Decorative Elements */}
        <div style={styles.glowOverlay}></div>

        <div style={styles.card}>
          {/* Logo Wrapper */}
          <div style={styles.logoContainer}>
            <img src={logo} style={styles.logo} alt="Boseth Logo" />
          </div>

          {/* Status Badge */}
          <div style={styles.badge}>
            <span style={styles.badgeDot}></span>
            System Status: API Live
          </div>

          {/* Headings */}
          <h1 style={styles.title}>Boseth System</h1>
          <h2 style={styles.subtitle}>Portal Under Construction</h2>

          <hr style={styles.divider} />

          {/* Informational Text */}
          <p style={styles.description}>
            Our medical management web system is currently undergoing final deployment phases.
            The database links and security parameters are being optimized for production.
          </p>

          {/* Loading/Progress Indicator */}
          <div style={styles.progressSection}>
            <div style={styles.progressLabels}>
              <span>Frontend Compiling</span>
              <strong>80%</strong>
            </div>
            <div style={styles.progressBarTrack}>
              <div style={styles.progressBarFill}></div>
            </div>
          </div>

          {/* Footer Meta */}
          <footer style={styles.footer}>
            &copy; {new Date().getFullYear()} Boseth Org. All rights reserved.
          </footer>
        </div>
      </div>
  );
}

// --- High Quality Premium CSS Styles ---
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#0f172a', // Premium deep slate background
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    overflow: 'hidden',
    position: 'relative',
    margin: 0,
    padding: '20px',
    boxSizing: 'border-box',
  },
  glowOverlay: {
    position: 'absolute',
    width: '400px',
    height: '400px',
    background: 'radial-gradient(circle, rgba(56, 189, 248, 0.15) 0%, rgba(15, 23, 42, 0) 70%)',
    top: '20%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
  },
  card: {
    backgroundColor: 'rgba(30, 41, 59, 0.7)', // Sleek glassmorphism look
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '24px',
    padding: '40px 30px',
    maxWidth: '480px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2)',
    zIndex: 2,
    boxSizing: 'border-box',
    // Added structural layout properties to force flawless horizontal centering
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logoContainer: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '50%',
    padding: '20px',
    marginBottom: '20px',
    border: '1px solid rgba(255, 255, 255, 0.05)',
  },
  logo: {
    height: '90px',
    width: 'auto',
    objectFit: 'contain',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'rgba(16, 185, 129, 0.1)',
    color: '#34d399',
    padding: '6px 14px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '500',
    marginBottom: '24px',
    border: '1px solid rgba(16, 185, 129, 0.2)',
  },
  badgeDot: {
    width: '8px',
    height: '8px',
    backgroundColor: '#10b981',
    borderRadius: '50%',
    display: 'inline-block',
    boxShadow: '0 0 8px #10b981',
  },
  title: {
    color: '#ffffff',
    fontSize: '28px',
    fontWeight: '700',
    margin: '0 0 4px 0',
    letterSpacing: '-0.5px',
  },
  subtitle: {
    color: '#94a3b8',
    fontSize: '18px',
    fontWeight: '400',
    margin: '0 0 20px 0',
  },
  divider: {
    border: 'none',
    borderTop: '1px solid rgba(255, 255, 255, 0.08)',
    margin: '0 0 20px 0',
    width: '100%', // Ensures line stretches cleanly across the card layout
  },
  description: {
    color: '#cbd5e1',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: '0 0 30px 0',
  },
  progressSection: {
    textAlign: 'left',
    marginBottom: '20px',
    width: '100%', // Ensures progress bar matches card boundaries perfectly
  },
  progressLabels: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#94a3b8',
    fontSize: '13px',
    marginBottom: '8px',
  },
  progressBarTrack: {
    width: '100%',
    height: '6px',
    backgroundColor: '#334155',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  progressBarFill: {
    width: '80%', // Maintained exactly at 80%
    height: '100%',
    background: 'linear-gradient(90deg, #0ea5e9 0%, #38bdf8 100%)',
    borderRadius: '10px',
    boxShadow: '0 0 10px rgba(56, 189, 248, 0.5)',
  },
  footer: {
    color: '#64748b',
    fontSize: '12px',
    marginTop: '30px',
  },
};

export default App;